export default __webpack_public_path__ + "static/media/Hive_Logo_Black.ebf93161.svg";